module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mx-auto swipe",
    attrs: {
      "elevation": "0"
    }
  }, [(!_vm.isSetProfile) ? _c('v-slide-group', {
    attrs: {
      "show-arrows": "",
      "mandatory": "mandatory"
    },
    model: {
      value: (_vm.indexPreview),
      callback: function($$v) {
        _vm.indexPreview = $$v
      },
      expression: "indexPreview"
    }
  }, _vm._l((_vm.files), function(f, index) {
    return _c('v-slide-item', {
      key: index,
      staticClass: "mb-2",
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;
          var toggle = ref.toggle;

          return [_c('v-chip', {
            staticClass: "ma-1 elevation-2 py-4",
            attrs: {
              "close": "close",
              "color": active ? 'primary ' : 'white grey--text'
            },
            on: {
              "click:close": function($event) {
                return _vm.removeFile(index)
              },
              "click": function($event) {
                toggle,
                _vm.previewFile(index)
              }
            }
          }, [_c('v-avatar', {
            attrs: {
              "left": "",
              "color": !active ? 'secondary primary--text' : 'white primary--text'
            }
          }, [(f.type === 'image/png' || f.type === 'image/jpg' || f.type === 'image/jpeg') ? _c('v-icon', {
            attrs: {
              "size": "16"
            }
          }, [_vm._v("insert_photo")]) : (f.type === 'application/pdf') ? _c('v-icon', {
            attrs: {
              "size": "16"
            }
          }, [_vm._v("picture_as_pdf")]) : (f.type === 'text/plain') ? _c('v-icon', {
            attrs: {
              "size": "16"
            }
          }, [_vm._v("description")]) : _c('v-icon', {
            attrs: {
              "size": "16"
            }
          }, [_vm._v("description")])], 1), _vm._v(_vm._s(f.name))], 1)]
        }
      }], null, true)
    })
  }), 1) : _vm._e(), (!_vm.isSetProfile) ? _c('v-btn', {
    staticClass: "left",
    attrs: {
      "color": "primary",
      "fab": "fab",
      "large": "large"
    },
    on: {
      "click": function($event) {
        return _vm.swipePrev()
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1) : _vm._e(), (!_vm.isSetProfile) ? _c('v-btn', {
    staticClass: "right",
    attrs: {
      "color": "primary",
      "fab": "fab",
      "large": "large"
    },
    on: {
      "click": function($event) {
        return _vm.swipeNext()
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1) : _vm._e(), _c('v-expand-transition', [_c('v-card', {
    attrs: {
      "height": _vm.isMovil ? 'calc(100vh - 258px)' : 500
    }
  }, [(_vm.imgSRC) ? _c('div', {
    staticClass: "background-filter position-relative",
    style: (("background-image : url(" + _vm.imgSRC + ")"))
  }) : _vm._e(), _c('div', {
    staticClass: "box-preview-image",
    class: {
      'position-center': _vm.filePreview.type !== 'image/png' && _vm.filePreview.type !== 'image/jpg' && _vm.filePreview.type !== 'image/jpeg'
    }
  }, [(_vm.filePreview.type === 'image/png' || _vm.filePreview.type === 'image/jpg' || _vm.filePreview.type === 'image/jpeg' && _vm.imgSRC) ? _c('v-img', {
    staticClass: "text-end",
    attrs: {
      "src": _vm.imgSRC,
      "height": "400",
      "contain": "contain"
    }
  }) : _c('div', {
    staticClass: "d-flex ai-center jc-center fd-column"
  }, [(_vm.filePreview.type === 'application/pdf') ? _c('img', {
    attrs: {
      "src": require("../../static/img/icons-actividad/pdf.png"),
      "width": "70"
    }
  }) : (_vm.filePreview.type === 'text/plain') ? _c('img', {
    attrs: {
      "src": require("../../static/img/icons-actividad/txt.png"),
      "width": "100"
    }
  }) : (_vm.filePreview.type === 'application/x-msdownload') ? _c('img', {
    attrs: {
      "src": require("../../static/img/icons-actividad/exe.png"),
      "width": "100"
    }
  }) : (_vm.filePreview.type === 'application/x-zip-compressed') ? _c('img', {
    attrs: {
      "src": require("../../static/img/icons-actividad/zip.png"),
      "width": "100"
    }
  }) : (_vm.filePreview.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ? _c('img', {
    attrs: {
      "src": require("../../static/img/icons-actividad/xls.png"),
      "width": "100"
    }
  }) : (_vm.filePreview.type === 'video/mp4') ? _c('img', {
    attrs: {
      "src": require("../../static/img/icons-actividad/mp4.png"),
      "width": "100"
    }
  }) : (_vm.filePreview.type === 'application/msword' || _vm.filePreview.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') ? _c('img', {
    attrs: {
      "src": require("../../static/img/icons-actividad/doc.png"),
      "width": "100"
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../static/img/icons-actividad/search.png"),
      "width": "85"
    }
  }), _c('small', {
    staticClass: "grey--text font-weight-700 font-size-15 mt-4"
  }, [_vm._v(_vm._s(_vm.filePreview.name))])], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-535c7e18","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_preview_files.vue
// module id = 500
// module chunks = 1